import { Play } from 'lucide-react';
import { Button } from '../ui/button';
import { demoTimeLabel } from './useDemoSession';

/**
 * The demo's sign-up, on a phone or tablet. The sidebar carries it on a
 * desktop, but below lg the sidebar is a closed drawer, so without this a
 * phone visitor in the demo saw no way to sign up at all.
 *
 * Fixed to the bottom of the screen; Layout leaves room for it (DemoBarSpacer).
 */
export function DemoBar({ minutesLeft, onSignUp }) {
  const time = demoTimeLabel(minutesLeft);
  return (
    <div
      className="lg:hidden fixed inset-x-0 bottom-0 z-30 bg-inverse text-inverse-foreground px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] flex items-center gap-3"
      data-testid="demo-bar"
    >
      <div className="flex-1 min-w-0">
        <p className="flex items-center gap-2 text-sm">
          <Play className="w-3.5 h-3.5 shrink-0" />
          <span className="font-medium">You're in the demo</span>
          {time && <span className="text-inverse-muted whitespace-nowrap">· {time}</span>}
        </p>
        {/* A phone sees a cut-down app: say so, so it isn't judged on this alone */}
        <p className="text-sm text-inverse-muted">More features on desktop</p>
      </div>
      <Button
        size="sm"
        onClick={onSignUp}
        className="bg-background text-foreground hover:bg-mist shrink-0"
        data-testid="demo-bar-signup"
      >
        Start free
      </Button>
    </div>
  );
}

/** The bar's height at the foot of the page, so it never hides the last row. */
export function DemoBarSpacer() {
  return <div className="lg:hidden h-20" aria-hidden="true" />;
}
